import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";

@Injectable()
export class StorageProvider {


    constructor(private storage: Storage) {
    }

    removeData(key) {
        return new Promise<any>((resolve, reject) => {
            this.storage.remove(key).then(() => resolve).catch(() => reject());
        });
    }

    checkForExistance(key) {
        return new Promise<any>((resolve, reject) => {
            this.storage.keys().then((data) => {
                let table = data.includes(key);
                if (table) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        });
    }

    getSaved(type, isToken: boolean = false): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.storage.get(type).then((data) => {
                if (data) {
                    if (isToken)
                        resolve(data);
                    else
                        resolve(JSON.parse(data));
                } else {
                    resolve(null);
                }
            });
        });
    }
    saveData(data, type): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.storage.set(type, JSON.stringify(data)).then(() => resolve(null));
        });
    }


}


// WEBPACK FOOTER //
// /src/providers/storage-service/storage-service.ts